<template>
    <div>
        <h1 class="display-heading">Profile Verification Details</h1>
        <form data-vv-scope="user-dependent" @submit.prevent="validateTierForm">
            <!-- <div v-if="!isNewUser" class="alert alert-success" role="alert">
                User with entered identity card number "{{ form.in }}" has an existing user account on {{ companyName }}.<br>
                Hence his/her personal details is not editable.
            </div> -->
            <div class="row">
                <div class="col">
                    <table class>
                        <thead>
                            <tr>
                                <th scope="col" class="col col-4">Front IC</th>
                                <th scope="col" class="col col-4">Back IC</th>
                                <th scope="col" class="col col-4">Selfie with IC</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <img class="col" :src="data.iffp" />
                                </td>
                                <td>
                                    <img class="col" :src="data.ibfp" />
                                </td>
                                <td>
                                    <img class="col" :src="data.isfp" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col">
                    <table class="table table-hover">
                        <col width="150">
                        <col>
                        <col>
                        <col width="100">
                        <thead>
                            <tr>
                                <th scope="col">Category</th>
                                <th scope="col">User Details</th>
                                <th scope="col">OCR Readings</th>
                                <th scope="col">Result</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>Full Name</th>
                                <td>{{data.ufn}}</td>
                                <td>{{data.ofn}}</td>
                                <td>
                                    <span :class="'badge badge-pill ' + getResultClass(data.ufn.toUpperCase(), data.ofn.toUpperCase())">
                                        {{getResult(data.ufn.toUpperCase(), data.ofn.toUpperCase())}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>NRIC</th>
                                <td>{{data.uin}}</td>
                                <td>{{data.oin}}</td>
                                <td>
                                    <span :class="'badge badge-pill ' + getResultClass(data.uin.toUpperCase(), data.oin.toUpperCase())">
                                        {{getResult(data.uin.toUpperCase(), data.oin.toUpperCase())}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>Birth Date</th>
                                <td>{{data.ubd}}</td>
                                <td>{{data.obd}}</td>
                                <td>
                                    <span :class="'badge badge-pill ' + getResultClass(data.ubd, data.obd)">
                                        {{getResult(data.ubd, data.obd)}}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th>Gender</th>
                                <td>{{data.ug ? genders.find(g => g.value == data.ug).text : ""}}</td>
                                <td>{{data.og ? genders.find(g => g.value == data.og).text : ""}}</td>
                                <td>
                                    <span :class="'badge badge-pill ' + getResultClass(data.ug, data.og)">
                                        {{getResult(data.ug, data.og)}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card">
                <div class="card-header">Verify Account</div>
                <div class="card-body">
                    <div class="mb-2">
                        Current Status: <b :class="getRequestStatusClass(data.mv)">{{getRequestStatus(data.mv)}}</b>
                    </div>
                    <div>
                        <button type="button" class="btn btn-success mr-2" @click="approveKyc">Approve</button>
                        <!-- <button type="button" class="btn btn-primary mr-2" @click="resendKyc">Request Resend</button> -->
                        <button type="button" class="btn btn-danger mr-2" @click="rejectKyc">Reject</button>
                    </div>
                </div>
            </div>
            <br />

            <div>
                <div>
                    <router-link class="btn btn-secondary mr-2 mb-2" :to="{'name': 'profile-verification'}">Back to List</router-link>
                </div>
            </div>
        </form>

        <popup-modal ref="popupAlert" :hasCloseButton="false" :title="submitTitle">
            <template slot="content">
                <p v-html="submitMessage">
                    {{submitMessage}}
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary" @click="dismissSubmitMessage">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import $ from 'jquery';
import {
    convertDateToDDMMYYYY
} from '@/utilities';
import identificationTypes from '@/config/identificationTypes';
import relationshipTypes from '@/config/relationshipTypes';
import {
    mask
} from 'vue-the-mask';
import popupModal from '@/components/popup-modal';
import genders from '@/config/genders';
export default {
    'name': '',
    'components': {
        popupModal
    },
    'directives': {
        mask
    },
    'computed': {
        ProfileVerificationId () {
            return this.$route.name === 'profile-verification-detail' ? this.$route.params.id : null;
        },
        identificationTypeValidation () {
            let minIdentificationType = this.identificationTypes[0].value;
            let maxIdentificationType = this.identificationTypes[this.identificationTypes.length - 1].value;

            return `required|between:${minIdentificationType},${maxIdentificationType}`;
        }
    },
    mounted () {
        if (this.ProfileVerificationId) {
            this.axios.get('Kyc/GetKycDetails', {
                'params': {
                    'profileVerificationId': this.ProfileVerificationId
                }
            }).then(({
                data
            }) => {
                let ProfileVerificationData = data.data;
                this.data.pvi = ProfileVerificationData.pvi;
                this.data.ufn = ProfileVerificationData.ufn ? ProfileVerificationData.ufn : '';
                this.data.uin = ProfileVerificationData.uin ? ProfileVerificationData.uin : '';
                this.data.ubd = ProfileVerificationData.ubd ? convertDateToDDMMYYYY(ProfileVerificationData.ubd) : '';
                this.data.ug = ProfileVerificationData.ug;
                this.data.ofn = ProfileVerificationData.ofn ? ProfileVerificationData.ofn : '';
                this.data.oin = ProfileVerificationData.oin ? ProfileVerificationData.oin : '';
                this.data.obd = ProfileVerificationData.obd ? convertDateToDDMMYYYY(ProfileVerificationData.obd) : '';
                this.data.og = ProfileVerificationData.og;
                this.data.ov = ProfileVerificationData.ov;
                this.data.mv = ProfileVerificationData.mv;
                this.data.iffp = ProfileVerificationData.iffp;
                this.data.ibfp = ProfileVerificationData.ibfp;
                this.data.isfp = ProfileVerificationData.isfp;
            }).catch(() => {});
        } else {
            // Error??
        }
        $('[data-toggle="tooltip"]').tooltip();
    },
    data () {
        return {
            'data': {
                'pvi': null,
                'ufn': '',
                'uin': '',
                'ubd': null,
                'ug': null,
                'ofn': '',
                'oin': '',
                'obd': null,
                'og': null,
                'ov': null,
                'mv': null,
                'iffp': null,
                'ibfp': null,
                'isfp': null
            },
            'isSaving': false,
            'submitTitle': '',
            'submitMessage': '',
            identificationTypes,
            relationshipTypes,
            genders
        };
    },
    'methods': {
        getResult (u, o) {
            if (u === o) return 'Pass';
            return 'Fail';
        },
        getResultClass (u, o) {
            if (u === o) return 'badge-success';
            return 'badge-danger';
        },
        dismissSubmitMessage () {
            this.$refs.popupAlert.hide();
        },
        getRequestStatus (s) {
            switch (s) {
            case 1:
                return 'Pending';
            case 2:
                return 'Approved';
            case 3:
                return 'Rejected';
            case 4:
                return 'Requested Resend';
            default:
                return 'Not Sent';
            }
        },
        getRequestStatusClass (s) {
            switch (s) {
            case 1:
                return 'text-warning';
            case 2:
                return 'text-success';
            case 3:
                return 'text-danger';
            case 4:
                return 'text-primary';
            default:
                return 'text-secondary';
            }
        },
        approveKyc () {
            this.axios.post('Kyc/ApproveKyc', {
                'pvi': this.data.pvi
            }).then(() => {
                this.submitTitle = 'Success';
                this.submitMessage = 'KYC has been successfuly approved. ';
                this.data.mv = 2;
                this.$refs.popupAlert.show();
            }).catch((error) => {
                this.submitTitle = 'Error';
                if (error.response.data) {
                    this.submitMessage = error.response.data.message;
                } else {
                    this.submitMessage = 'Error approving KYC. Please try again.';
                }
                this.$refs.popupAlert.show();
            });
        },
        rejectKyc () {
            this.axios.post('Kyc/RejectKyc', {
                'pvi': this.data.pvi
            }).then(() => {
                this.submitTitle = 'Success';
                this.submitMessage = 'KYC has been successfuly rejected. ';
                this.data.mv = 3;
                this.$refs.popupAlert.show();
            }).catch((error) => {
                this.submitTitle = 'Error';
                if (error.response.data) {
                    this.submitMessage = error.response.data.message;
                } else {
                    this.submitMessage = 'Error rejecting KYC. Please try again.';
                }
                this.$refs.popupAlert.show();
            });
        }
        // resendKyc () {
        //     this.axios.post('Kyc/ResendKyc', {
        //         'pvi': this.data.pvi
        //     }).then(() => {
        //         this.submitTitle = 'Success';
        //         this.submitMessage = 'KYC has been successfuly requested resubmission. ';
        //         this.data.mv = 4;
        //         this.$refs.popupAlert.show();
        //     }).catch((error) => {
        //         this.submitTitle = 'Error';
        //         if (error.response.data) {
        //             this.submitMessage = error.response.data.message;
        //         } else {
        //             this.submitMessage = 'Error requesting KYC resubmission. Please try again.';
        //         }
        //         this.$refs.popupAlert.show();
        //     });
        // }
    }
};

</script>

<style>

</style>
